export default {"src":"/_next/static/image/public/images/flags/flag_48.2b941906dcabbb41820428f9bb6b159e.svg","height":16,"width":24};